//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import theLoading from "~/components/common/loading/TheLoading.vue";
import theManagerSideNav from "~/components/kccam/manager/sideNav/TheManagerSideNav.vue";
import {mapActions} from "vuex";

export default {
    components: {
        theLoading,
        theManagerSideNav,
    },
    data() {
        return {
            // scroll
            scroll: false,
            sideMenuProp: "",

            sideNameArray: ["제품관리", "마켓관리", "문서관리", "팝업관리", "고객지원관리"],
            sideName: "",

            topMenuProp: "",

            // sidebar 보이기 여부 (메인에선 안보임)
            sideNav: false,
        };
    },
    mounted() {
        if (!process.client) {
            return;
        }
        // 스크롤 관련
        window.addEventListener("scroll", this.onScroll);
        // console.log(this.sideMenuProp);

        // sidebar 보이기 여부 (메인에선 안보임)
        this.sideNavVisible(this.$route.path);

        // 페이지가 시작될때 url을 가져옴
        this.getTopMenuKeyUrl();
        // console.log("this.getTopMenuKeyUrl() :", this.getTopMenuKeyUrl());
    },
    beforeDestroy() {
        if (!process.client) {
            return;
        }
        // 스크롤 관련
        window.removeEventListener("scroll", this.onScroll);
    },
    computed: {
        loadingIndicator() {
            return this.$nuxt.$root.$loading.percent;
        },
    },
    watch: {
        $route() {
	        // sidebar 보이기 여부 (메인에선 안보임)
            this.sideNavVisible(this.$route.path);
	        // 페이지가 시작될때 url을 가져옴
	        this.getTopMenuKeyUrl();
        },
    },
    methods: {
        // 스크롤 top 으로
        goTop() {
            animateScrollTo(0);
        },

        // 스크롤 관련
        onScroll(e) {
            // let scrollPosition = window.scrollY || document.documentElement.scrollTop;
            // let scrollPosition = document.querySelector("html").scrollTop;
            // let headerTop = document.getElementById("header").offsetTop;
            // if (scrollPosition > headerTop) {
            //     this.scroll = true;
            // } else {
            //     this.scroll = false;
            // }
        },
        activeMment() {},

        // 현재페이지의 3번째mgnt를 가져옵니다
        getTopMenuKeyUrl() {
            const keyUrl = this.$route.fullPath.split("/")[3];
            this.sideMenuProp = keyUrl;
        },

        getMenuActive(currentUrl, index) {
            let pathUrl = this.$route.fullPath;
            if (-1 < pathUrl.indexOf(currentUrl)) {
                this.getActiveName(index);
                return "active";
            } else {
                return "";
            }
        },

        getActiveName(index) {
            this.sideName = this.sideNameArray[index];
        },

        // setSideTit(index) {
        //     let value = this.sideNameArray[index];
        //     console.log(this.sideNameArray);
        //     return value;
        // },

        // sidebar 보이기 여부 (메인에선 안보임)
        sideNavVisible(path) {
            if (-1 < path.indexOf("/main")) {
                this.sideNav = false;
            } else {
                this.sideNav = true;
            }
        },
		formatToday(){
        	let date = new Date();
			let dayStrArr = ['일','월','화','수','목','금','토','일'];
			let today = this.$common.leadingZeros( date.getFullYear(), 4 ) +
				"-" + this.$common.leadingZeros( date.getMonth() + 1, 2 ) +
				"-" + this.$common.leadingZeros( date.getDate(), 2 ) +
				" " + '[' + dayStrArr[date.getDay()] + ']';
			return today;
		},
		...mapActions({
			logoutUser: "login/logout",
		}),

    },
};
